<template>
  <div class="page assistente-recomendacao-page">
    <v-tabs v-model="aba" class="assistente-abas" color="primario">
      <v-tab>Configuração</v-tab>
      <v-tab>Consulta</v-tab>
    </v-tabs>
    <v-tabs-items v-model="aba" :dark="darkEnabled">
      <v-tab-item>
        <div v-if="carregando" class="assistente-loading">
          <v-progress-circular indeterminate color="primary" />
        </div>
        <template v-else>
      
      <Panel
      lineColor="var(--primary-color)"
      class="assistente-panel"
      id="card-nome-assistente"
      >
        <p class="nota-informativa">
          <v-icon size="14" color="primario">fas fa-info-circle</v-icon>
          <strong>Um nome para os dois canais.</strong>
          O nome é opcional e fica acima dos blocos. Salvar com um canal
          habilitado publica esse assistente, sem passo extra.
        </p>
        <div class="section-header">
          <div>
            <h3 class="section-title">Nome do assistente</h3>
            <p class="section-subtitle">
              O mesmo nome vale para o Assistente de Compras e o Assistente de
              Vendas.
            </p>
          </div>
        </div>
        <FormField
          label="Nome"
          v-model="draft.nome"
          maxLength="40"
          counter
          clearable
          placeholder="Opcional"
          hint="Deixe em branco para manter o nome vazio."
          persistenthint
        />
      </Panel>

      <Panel
        lineColor="var(--primary-color)"
        class="assistente-panel"
        id="card-assistente-compras"
      >
        <div class="section-header">
          <div>
            <h3 class="section-title">Assistente de Compras</h3>
            <p class="section-subtitle">
              Canal da loja. O rótulo do canal é fixo.
            </p>
          </div>
          <div class="assistente-status-atual">
            <span class="assistente-status-label">Status:</span>
            <Chip
              :color="draft.compras.habilitado ? 'green' : 'orange'"
              :text="draft.compras.habilitado ? 'Habilitado' : 'Desabilitado'"
              small
            />
          </div>
        </div>

        <label class="field-label">Habilitado</label>
        <FormSwitch
          id="switch-assistente-compras"
          v-model="draft.compras.habilitado"
          :label="draft.compras.habilitado ? 'Habilitado' : 'Desabilitado'"
        />

        <FormSelect
          label="Segmentos"
          v-model="draft.compras.segmentos"
          :options="opcoesSegmentos"
          multiple
          clearable
          messages="Nenhum segmento selecionado significa todos os clientes da loja."
        />
      </Panel>

      <Panel
        lineColor="var(--primary-color)"
        class="assistente-panel"
        id="card-assistente-vendas"
      >
        <div class="section-header">
          <div>
            <h3 class="section-title">Assistente de Vendas</h3>
            <p class="section-subtitle">
              Canal da jornada. O rótulo do canal é fixo e não usa segmento.
            </p>
          </div>
          <div class="assistente-status-atual">
            <span class="assistente-status-label">Status:</span>
            <Chip
              :color="draft.vendas.habilitado ? 'green' : 'orange'"
              :text="draft.vendas.habilitado ? 'Habilitado' : 'Desabilitado'"
              small
            />
          </div>
        </div>

        <label class="field-label">Habilitado</label>
        <FormSwitch
          id="switch-assistente-vendas"
          v-model="draft.vendas.habilitado"
          :label="draft.vendas.habilitado ? 'Habilitado' : 'Desabilitado'"
        />
      </Panel>

      <div class="assistente-barra-acoes">
        <Panel lineColor="var(--primary-color)" id="barra-acoes-salvamento">
          <div class="assistente-barra-conteudo">
            <div class="assistente-status-alteracoes">
              <template v-if="erroApi">
                <v-icon size="14" color="error"
                  >fas fa-exclamation-circle</v-icon
                >
                <span class="texto-erro">{{ erroApi }}</span>
              </template>
              <template v-else-if="dirty">
                <v-icon size="14" color="warning">fas fa-info-circle</v-icon>
                <span class="texto-alerta">
                  Você possui alterações não salvas na configuração do
                  assistente.
                </span>
              </template>
              <template v-else>
                <v-icon size="14" color="success">fas fa-check-circle</v-icon>
                <span>Nenhuma alteração pendente.</span>
              </template>
            </div>

            <div class="assistente-barra-botoes">
              <FormButton
                type="perigo"
                text="Cancelar"
                id="btn-cancelar-assistente"
                :disabled="!dirty || salvando"
                @click="cancelar"
              />
              <FormButton
                type="submissao"
                text="Salvar"
                id="btn-salvar-assistente"
                :disabled="!dirty"
                :loading="salvando"
                @click="salvar"
              />
            </div>
          </div>
        </Panel>
      </div>
        </template>
      </v-tab-item>
      <v-tab-item>
        <AssistenteRecomendacaoConsulta v-if="aba === 1" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import FormButton from "@/components/form/FormButton";
import FormField from "@/components/form/FormField";
import FormSelect from "@/components/form/FormSelect";
import FormSwitch from "@/components/form/FormSwitch";
import Panel from "@/components/Panel";
import Chip from "@/components/Chip";
import AssistenteRecomendacaoConsulta from "./AssistenteRecomendacaoConsulta";
import { mapGetters } from "vuex";
import { SEGMENTO_CLIENTE_LIST } from "@/store/actions/segmento";
import {
  ASSISTENTE_RECOMENDACAO_OBTER,
  ASSISTENTE_RECOMENDACAO_SALVAR
} from "@/store/actions/assistente-recomendacao";
import {
  normalizarConfig,
  configParaPayload,
  mensagemErroApi
} from "./assistente-recomendacao-form";
import * as _ from "lodash";

export default {
  name: "AssistenteRecomendacao",
  components: {
    FormButton,
    FormField,
    FormSelect,
    FormSwitch,
    Panel,
    Chip,
    AssistenteRecomendacaoConsulta
  },
  data() {
    return {
      aba: 0,
      carregando: true,
      salvando: false,
      erroApi: "",
      opcoesSegmentos: [],
      configSalva: normalizarConfig(null),
      draft: normalizarConfig(null)
    };
  },
  computed: {
    ...mapGetters(["getFornecedorId", "darkEnabled"]),
    dirty() {
      return !_.isEqual(
        configParaPayload(this.draft),
        configParaPayload(this.configSalva)
      );
    }
  },
  created() {
    this.carregar();
  },
  methods: {
    aplicarConfig(config) {
      this.configSalva = normalizarConfig(config);
      this.draft = normalizarConfig(config);
    },
    carregarSegmentos() {
      return this.$store
        .dispatch(SEGMENTO_CLIENTE_LIST, {
          idfornecedor: this.getFornecedorId
        })
        .then(lista => {
          this.opcoesSegmentos = (lista || []).map(item => ({
            text: item.nome,
            value: String(item.idsegmentocliente || "")
              .trim()
              .toLowerCase()
          }));
        })
        .catch(() => {
          this.opcoesSegmentos = [];
        });
    },
    carregar() {
      this.carregando = true;
      this.erroApi = "";
      this.carregarSegmentos();
      this.$store
        .dispatch(ASSISTENTE_RECOMENDACAO_OBTER)
        .then(config => {
          this.aplicarConfig(config);
        })
        .catch(err => {
          this.aplicarConfig(null);
          this.erroApi = mensagemErroApi(err);
        })
        .finally(() => {
          this.carregando = false;
        });
    },
    cancelar() {
      this.draft = normalizarConfig(this.configSalva);
      this.erroApi = "";
    },
    salvar() {
      if (!this.dirty || this.salvando) {
        return;
      }
      this.salvando = true;
      this.erroApi = "";
      this.$store
        .dispatch(ASSISTENTE_RECOMENDACAO_SALVAR, configParaPayload(this.draft))
        .then(config => {
          this.aplicarConfig(config || this.draft);
          this.salvando = false;
          this.$vueOnToast.pop(
            "success",
            "Configuração do assistente salva com sucesso."
          );
        })
        .catch(err => {
          this.salvando = false;
          this.erroApi = mensagemErroApi(err);
        });
    }
  }
};
</script>

<style scoped>
.assistente-recomendacao-page {
  padding-bottom: 16px;
}

.assistente-abas {
  margin-bottom: 16px;
}

.nota-informativa,
.nota-canal {
  background: #f5f7fa;
  border-left: 3px solid var(--primary-color);
  border-radius: 8px;
  padding: 10px 12px;
  margin-bottom: 20px;
  color: #6a6c6f;
  text-align: left;
}

.nota-canal {
  margin-top: 8px;
  margin-bottom: 0;
}

.nota-informativa .v-icon,
.nota-canal .v-icon {
  margin-right: 8px;
}

.assistente-loading {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}

.assistente-panel {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.section-title,
.section-subtitle,
.field-label {
  text-align: left;
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.section-subtitle {
  color: #6a6c6f;
  font-size: 16px;
  margin-bottom: 16px;
}

.assistente-status-atual {
  display: flex;
  align-items: center;
  gap: 4px;
}

.assistente-status-label {
  color: #6a6c6f;
}

.field-label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
}

.assistente-barra-acoes {
  position: sticky;
  bottom: 8px;
  z-index: 5;
}

.assistente-barra-conteudo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  text-align: left;
}

.assistente-status-alteracoes {
  display: flex;
  align-items: center;
  gap: 8px;
}

.texto-erro {
  color: var(--danger-color);
  font-weight: 600;
}

.texto-alerta {
  color: var(--alert-color);
}

.assistente-barra-botoes {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
</style>
